import 'ua-parser-js';
import * as UAParser from "ua-parser-js";

/** @internal */
export enum DeviceType {
    IOS,
    OTHER
}

/** @internal */
export function RuntimeDeviceType(): DeviceType {
    const parser = new UAParser();
    const os = parser.getOS();

    // if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) return DeviceType.IOS;
    // return DeviceType.OTHER;

    if(os.name.toLowerCase() == "ios") return DeviceType.IOS;
    return DeviceType.OTHER;
}

/** @internal */
export async function RuntimeDeviceHaveMicrophone(): Promise<boolean> {
    if (!navigator || !navigator.mediaDevices) return false;

    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices.some(x => x.kind == "audioinput");
}

/** @internal */
export async function RuntimeDeviceHaveWebCam(): Promise<boolean> {
    if (!navigator || !navigator.mediaDevices) return false;

    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices.some(x => x.kind == "videoinput");
}